<h3>{{ title }}</h3>

<p-table
  [value]="data"
  responsiveLayout="stack"
  [breakpoint]="'600px'"
  rowGroupMode="subheader"
  groupRowsBy="currencyCode">
  <ng-template pTemplate="caption">
    <div class="flex align-items-center justify-content-start">
      <p-button label="New" icon="pi pi-plus" class="mr-2 custom-text-button" (onClick)="onOpenCreate()"/>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th><div class="flex justify-content-center align-items-center">Description</div></th>
      <th><div class="flex justify-content-center align-items-center">Amount</div></th>
      <th>
        <div class="flex justify-content-center align-items-center">Currency</div>
      </th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td><div class="flex justify-content-center align-items-center">{{row.description}}</div></td>
      <td>
        <div class="flex justify-content-center align-items-center">
          {{ row.amount | currency: row.currencyCode }}
        </div>
      </td>
      <td>
        <div class="flex justify-content-center align-items-center">{{row.currencyCode}}</div>
      </td>
      <td>
        <div class="flex justify-content-end align-items-center gap-2">
          <p-button label="Edit" icon="pi pi-pencil" class="mr-2 custom-text-button" (onClick)="onOpenEdit(row)"/>
          <p-button label="Delete" icon="pi pi-trash" class="mr-2 custom-text-button" (onClick)="confirmDelete(row.id)"/>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="groupfooter" let-row>
    <tr>
      <td colspan="4" class="text-right font-bold pr-6">
        Total:
        {{ calculateTotalPerCurrency(row.currencyCode) | currency: row.currencyCode }}
      </td>
    </tr>
</ng-template>
</p-table>
